import { useReveal, revealCls } from "../useReveal";

// The core principle as a clickable left→right flow. Each node scrolls to its
// matching chapter below. learn → practice → compete → hunt.
const STEPS = [
    { id: "learn", title: "learn", desc: "structured academy — novice to red team" },
    { id: "practice", title: "practice", desc: "hands-on hacking labs in safe, legal sandboxes" },
    { id: "compete", title: "compete", desc: "live ctf events & a karma-ranked leaderboard" },
    { id: "hunt", title: "hunt", desc: "public bug bounty programs & real payouts" },
];

const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function StatBar() {
    const [ref, inView] = useReveal({ threshold: 0.25 });
    return (
        <section className="border-b border-white/[0.07] bg-[#070a10] relative overflow-hidden" data-testid="stat-bar" ref={ref}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-9 lg:py-11">
                <div className="mb-9">
                    <span className="font-mono text-[11px] text-cyan-400 tracking-[0.25em] uppercase">// the path</span>
                </div>

                {/* whole row reveals together — dots stay perfectly aligned */}
                <div className={`grid grid-cols-2 xl:grid-cols-4 gap-x-4 gap-y-9 ${revealCls(inView, 80).className}`} style={revealCls(inView, 80).style}>
                    {STEPS.map((s, i) => {
                        const last = i === STEPS.length - 1;
                        return (
                            <button type="button" key={s.id} onClick={() => scrollTo(s.id)}
                                    data-testid={`path-step-${s.id}`}
                                    className="group relative text-left cursor-pointer self-start">
                                {/* fixed-height node row → every dot aligns identically */}
                                <div className="relative h-2.5">
                                    {!last && (
                                        <>
                                            <span aria-hidden className="hidden xl:block absolute top-1/2 -translate-y-1/2 left-[5px] w-[calc(100%+1rem)] h-px bg-white/[0.08]" />
                                            <span aria-hidden
                                                  className="hidden xl:block absolute top-1/2 -translate-y-1/2 left-[5px] w-[calc(100%+1rem)] h-px bg-gradient-to-r from-cyan-400 to-cyan-400/30 origin-left transition-transform duration-700 ease-out"
                                                  style={{ transitionDelay: `${350 + i * 220}ms`, transform: inView ? "scaleX(1)" : "scaleX(0)" }} />
                                        </>
                                    )}
                                    <span className="absolute top-0 left-0 z-10 w-2.5 h-2.5 rounded-full bg-cyan-400 shadow-[0_0_12px_-1px_rgba(34,211,238,0.8)] ring-4 ring-[#070a10] group-hover:scale-125 transition-transform" />
                                </div>
                                <div className="mt-5">
                                    <span className="block font-bold text-slate-100 lowercase text-lg tracking-wide group-hover:text-cyan-300 transition-colors" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                                        {s.title}<span className="text-cyan-400">.</span>
                                    </span>
                                    <span className="mt-2 block font-mono text-[10px] xl:text-[11px] leading-relaxed text-slate-500 lowercase">
                                        {s.desc}
                                    </span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
